import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { usePixelTracking } from "@/hooks/usePixelTracking";
import OriginalHome from "./pages/OriginalHome";
import DamianKeyes from "./pages/DamianKeyes";
import ArtistEngine from "./pages/ArtistEngine";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import FreePlan from "./pages/FreePlan";
import LetsGo from "./pages/LetsGo";
import AdminLeads from "./pages/admin/Leads";
import HeroLab from "./pages/HeroLab";
import IntroLab from "./pages/IntroLab";
import JourneyLab from "./pages/JourneyLab";

import NotFound from "./pages/NotFound";

const queryClient = new QueryClient();

const AppRoutes = () => {
  usePixelTracking();
  
  return (
    <Routes>
      <Route path="/" element={<DamianKeyes />} />
      <Route path="/artist-engine" element={<ArtistEngine />} />
      <Route path="/privacy-policy" element={<PrivacyPolicy />} />
      <Route path="/releaseplan" element={<FreePlan />} />
      <Route path="/free-plan" element={<Navigate to="/releaseplan" replace />} />
      <Route path="/letsgo" element={<LetsGo />} />
      <Route path="/original-home" element={<OriginalHome />} />
      <Route path="/hero-lab" element={<HeroLab />} />
      <Route path="/intro-lab" element={<IntroLab />} />
      <Route path="/journey-lab" element={<JourneyLab />} />

      <Route path="/admin/leads" element={<AdminLeads />} />
      {/* ADD ALL CUSTOM ROUTES ABOVE THE CATCH-ALL "*" ROUTE */}
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
};

const App = () => (
  <QueryClientProvider client={queryClient}>
    <TooltipProvider>
      <Toaster />
      <Sonner />
      <BrowserRouter>
        <AppRoutes />
      </BrowserRouter>
    </TooltipProvider>
  </QueryClientProvider>
);

export default App;
